import {
  InjectedLLMJudge,
  LLMJudgeError,
  type InjectedInvoker,
} from "./shared.js";

/**
 * Claude Desktop host adapter for `LLMJudge`.
 *
 * Claude Desktop's natural surface for a single-shot decision query is a
 * **response on its own conversation surface** — the host poses the framed
 * prompt and returns the model's reply. The host injects that call; the
 * shared base supplies framing + parsing. Host-specific surface is the `host`
 * identifier (`"claude-desktop"`, matching the sessionArchive adapter
 * convention) and the typed error.
 */

/** Claude Desktop's response invoker — a `prompt in, string out` call. */
export type ClaudeDesktopInvoker = InjectedInvoker;

export class ClaudeDesktopLLMJudgeError extends LLMJudgeError {
  constructor(message: string, raw?: string) {
    super(message, raw);
    this.name = "ClaudeDesktopLLMJudgeError";
  }
}

export class ClaudeDesktopLLMJudge extends InjectedLLMJudge {
  readonly host = "claude-desktop";

  protected override makeError(message: string, raw?: string): Error {
    return new ClaudeDesktopLLMJudgeError(message, raw);
  }
}
